module.exports = __webpack_public_path__ + "img/24-image-1@2x.e2454237.png";